import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updatePartnerSubscriptionPricing } from '../services/partners';
import { partnerQueryKeys } from './query-keys';

export const useUpdatePartnerSubscriptionPricingMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: async ({ partnerProfileId, amount }) => {
      const result = await updatePartnerSubscriptionPricing({ partnerProfileId, amount });
      if (!result.success) {
        throw new Error(result.message || 'Failed to update partner subscription amount');
      }
      return result;
    },
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({ queryKey: partnerQueryKeys.all });
      await options.onSuccess?.(...args);
    },
  });
};
